<template>
  <div class="row row-spacing">
    <div class="col-md-12">
      <div class="row row-spacing mt-4">
        <div class="col-md-12">
          <div class="card table-responsive agreements-table-wrapper">
            <table class="table table-bordered agreements-table">
              <colgroup>
                <col class="column-contract-date">
                <col class="column-sales-order">
                <col class="column-product-bundle">
                <col class="column-status">
                <col class="column-sale">
                <col class="column-service-date">
                <col class="column-actions">
              </colgroup>
              <thead>
                <tr class="header-row">
                  <th class="sortable-header column-contract-date" @click="sortBy('agreementDate')">
                    Contract Date
                    <i :class="getSortIcon('agreementDate')"></i>
                  </th>
                  <th class="sortable-header column-sales-order" @click="sortBy('salesOrderNumber')">
                    Sales Order
                    <i :class="getSortIcon('salesOrderNumber')"></i>
                  </th>
                  <th class="sortable-header column-product-bundle" @click="sortBy('productBundle')">
                    Product Bundle
                    <i :class="getSortIcon('productBundle')"></i>
                  </th>
                  <th class="sortable-header column-status" @click="sortBy('agreementStatus')">
                    Status
                    <i :class="getSortIcon('agreementStatus')"></i>
                  </th>
                  <th class="sortable-header column-sale" @click="sortBy('saleNumber')">
                    Sale
                    <i :class="getSortIcon('saleNumber')"></i>
                  </th>
                  <th class="sortable-header column-service-date" @click="sortBy('serviceDate')">
                    Service Date
                    <i :class="getSortIcon('serviceDate')"></i>
                  </th>
                  <th class="column-actions" v-allowed:view="['ADMIN', 'CLIENT_ADMIN', 'STAFF']"></th>
                </tr>
                <tr class="filter-row">
                  <th>
                    <input type="text" class="form-control form-control-sm" placeholder="Filter..." v-model="columnFilters.contractDate" />
                  </th>
                  <th>
                    <input type="text" class="form-control form-control-sm" placeholder="Filter..." v-model="columnFilters.salesOrder" />
                  </th>
                  <th>
                    <input type="text" class="form-control form-control-sm" placeholder="Filter..." v-model="columnFilters.productBundle" />
                  </th>
                  <th>
                    <select class="form-control form-control-sm" v-model="columnFilters.status">
                      <option value="">All</option>
                      <option v-for="status in statusses" :key="status.value" :value="status.value">{{ status.label }}</option>
                    </select>
                  </th>
                  <th>
                    <input type="text" class="form-control form-control-sm" placeholder="Filter..." v-model="columnFilters.sale" />
                  </th>
                  <th>
                    <input type="text" class="form-control form-control-sm" placeholder="Filter..." v-model="columnFilters.serviceDate" />
                  </th>
                  <th v-allowed:view="['ADMIN', 'CLIENT_ADMIN', 'STAFF']">
                    <button class="btn btn-sm btn-secondary" @click="clearColumnFilters" v-tooltip="'Clear Filters'">
                      <i class="fa fa-times"></i>
                    </button>
                  </th>
                </tr>
              </thead>
              <tbody v-if="filteredAgreements.length > 0">
                <tr v-for="agree in filteredAgreements" :key="agree.agreementNumber" :class="agree.agreementStatus == 'EXPIRED' ? 'expiredAgreement' : ''">
                  <td class="text-left text-nowrap">
                    <span class="mr-2">{{ !agree.agreementDate || agree.agreementDate.split(" ")[0] == "1970-01-01" ? "Not set" : agree.agreementDate.split(" ")[0] }}</span>
                  </td>
                  <td class="text-left">
                    <span class="mr-2 blueLink cell-wrap" :title="`#${agree.salesOrderNumber} ${agree.name}`" @click="goToHaloSalesOrder(agree.salesOrderNumber)">#{{ agree.salesOrderNumber }} {{ agree.name }}</span>
                  </td>
                  <td class="text-left">
                    <span class="cell-wrap" :title="agree.productBundle">{{ agree.productBundle }}</span>
                  </td>
                  <td class="text-center">
                    <span class="mr-2" :class="getBadge(agree.agreementStatus)">{{ getStatus(agree.agreementStatus) }}</span>
                  </td>
                  <td class="text-left text-nowrap">
                    <span v-if="agree.saleNumber != 0" class="mr-2 blueLink" @click="viewSale(agree.saleNumber)">#{{ agree.saleNumber }} </span>
                  </td>
                  <td class="text-left text-nowrap">
                    <span class="mr-2">{{ !agree.serviceDate || agree.serviceDate.split(" ")[0] == "1970-01-01" ? "Not set" : agree.serviceDate.split(" ")[0] }}</span>
                  </td>

                  <td class="text-left actions-cell" v-allowed:view="['ADMIN', 'STAFF']">
                    <div v-if="agree.agreementStatus != 'ACTIVE' && agree.agreementStatus != 'EXPIRED'">
                      <!-- <button class="btn btn-green" v-if="agree.agreementStatus == 'PENDING'" v-tooltip="'Confirm Agreement'" @click="openAgreementModal(agree)"><i class="fa-solid fa-check"></i></button> -->
                      <!-- <button class="btn btn-primary" v-else-if="!(agree.agreementDate > 0) && agree.saleOrder.length == 0" v-tooltip="'Agreement not ready'" disabled><i class="fa-solid fa-x"></i></button> -->

                      <button class="btn btn-info" v-tooltip="'Edit Contract'" @click="openEditAgreeModal(agree)"><i class="fa-solid fa-pencil"></i></button>
                      <button type="button" class="btn btn-sm btn-primary" v-tooltip="'Delete Contract'" @click="deleteAgreement(agree.agreementNumber)"><em class="fa fa-trash fa-fw"></em></button>

                      <button class="btn btn-green" v-if="agree.saleNumber == 0" v-tooltip="'Link Sale'" @click="openLinkSaleModal(agree)"><i class="fa-solid fa-link"></i></button>
                      <button class="btn btn-primary" v-else v-tooltip="'Unlink Sale'" @click="unlinkSale(agree)"><i class="fa-solid fa-link-slash"></i></button>
                    </div>
                    <div v-else>
                      <button class="btn btn-info" v-tooltip="'View Contract'" @click="openEditAgreeModal(agree)"><i class="fa-solid fa-pencil"></i></button>
                      <button class="btn btn-primary" v-tooltip="'Unlink Sale'" @click="unlinkSale(agree)"><i class="fa-solid fa-link-slash"></i></button>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="7">No Contracts available</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <modal
        title="Edit Contract"
        ref="editAgreeModal"
        @save="saveAgreement()"
      >
        <div class="form-group row">
          <label class="col-md-4 col-form-label">Name:</label>
          <div class="col-md-12">
            <input
              type="text"
              class="form-control"
              v-model="selectedAgreement.name"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-4 col-form-label">Product Bundle:</label>
          <div class="col-md-12">
            <input
              type="text"
              class="form-control"
              v-model="selectedAgreement.productBundle"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-4 col-form-label">Product SKU:</label>
          <div class="col-md-12">
            <input
              type="text"
              class="form-control"
              disabled
              v-model="selectedAgreement.sku"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-6 col-form-label">Status:</label>
          <div class="col-md-6">
            <select
              class="form-control"
              v-model="selectedAgreement.agreementStatus"
            >
              <option
                v-for="status in statusses"
                :key="status.value"
                :value="status.value"
              >
                {{ status.label }}
              </option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-6 col-form-label">Contract Term (month): </label>
          <div class="col-md-6">
            <input
              type="text"
              class="form-control"
              v-model="selectedAgreement.term"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-6 col-form-label">Expiry Action:</label>
          <div class="col-md-6">
            <select
              class="form-control"
              v-model="selectedAgreement.expiryAction"
            >
              <option
                v-for="action in expiryActions"
                :key="action.value"
                :value="action.value"
              >
                {{ action.label }}
              </option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-6 col-form-label">Start Date:</label>
          <div class="col-md-6">
            <DateInput
              v-model="selectedAgreement.agreementDate"
              type="date"
              :clearable="true"
              placeholder="Select Agreement Date"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-6 col-form-label">Expiry Date:</label>
          <div class="col-md-6">
            <DateInput
              v-model="selectedAgreement.expiryDate"
              type="date"
              :clearable="true"
              placeholder="Select Expiry Date"
            />
          </div>
        </div>
      </modal>
      <modal
        title="Contract"
        ref="agreementModal"
        @save="confirmAgreement(selectedAgreement.agreementNumber)"
        save-text="Agree"
      >
        <div v-html="markdownToHtml"></div>
      </modal>
      <modal
        size="modal-lg"
        title="Link Sale to Contract"
        ref="linkSaleModal"
        @save="linkSale(selectedAgreement.agreementNumber)"
        save-text="Link Sale"
      >
        <div class="form-group row">
          <label class="col-md-3 col-form-label">Link Sale:</label>
          <div class="col-md-10">
            <multiselect
              v-model="selectedSale"
              :options="formattedSales"
              :searchable="true"
              label="displayLabel"
              placeholder="Select Existing Sale"
            ></multiselect>
          </div>
          <div class="col-md-2">
            
            <button class="btn btn-primary" v-tooltip="'Create Sale'" @click=goToSaleWizard>
              <i class="fa-solid fa-circle-plus"></i>
            </button>    

          </div>
        </div>
      </modal>
  </div>
</template>

<script>
import Modal from "@/components/GeneralComponents/Modal";
import DateInput from '@/components/GeneralComponents/InputControls/DateInput.vue';
import { marked } from 'marked';

export default {
  components: {
    Modal,
    DateInput,
  },
  data() {
    return {
      clientNumber: null,

      selectedAgreement: {},
      agreements: [],

      salesWithDescription: [],
      selectedSale: '',

      statusses: [],
      expiryActions: [],

      searchTerm: '',
      showTable: true,
      markdown:  "",

      sortKey: 'salesOrderNumber',
      sortOrder: 'asc',

      columnFilters: {
        contractDate: '',
        salesOrder: '',
        productBundle: '',
        status: '',
        sale: '',
        serviceDate: ''
      }
    }
  },
  mounted() {
    this.clientNumber = this.$route.params.clientNumber;  
    if (this.userContainsPermission(["CLIENT"])) {
        this.$root.$emit("SET_CLIENT_PAGE_TITLE", 'Agreements'); 
    }
    this.getAgreements();
    this.getStatuses();
    this.getActions();
  },
  computed: {
    formattedSales() {
      return this.salesWithDescription.map(rec => ({
        ...rec, displayLabel: `[${rec.productDescription}] #${rec.sale.saleNumber} - ${rec.sale.toString}`
      }));
    },
    filteredAgreements() {
      let result = this.agreements.filter(a => {
        const contractDate = a.agreementDate ? a.agreementDate.split(" ")[0] : '';
        const contractDateMatch = this.columnFilters.contractDate === '' ||
          contractDate.includes(this.columnFilters.contractDate);

        const salesOrderMatch = this.columnFilters.salesOrder === '' ||
          String(a.salesOrderNumber).includes(this.columnFilters.salesOrder) ||
          (a.name && a.name.toLowerCase().includes(this.columnFilters.salesOrder.toLowerCase()));

        const productBundleMatch = this.columnFilters.productBundle === '' ||
          (a.productBundle && a.productBundle.toLowerCase().includes(this.columnFilters.productBundle.toLowerCase()));

        const statusMatch = this.columnFilters.status === '' ||
          a.agreementStatus === this.columnFilters.status;

        const saleMatch = this.columnFilters.sale === '' ||
          String(a.saleNumber).includes(this.columnFilters.sale);

        const serviceDate = a.serviceDate ? a.serviceDate.split(" ")[0] : '';
        const serviceDateMatch = this.columnFilters.serviceDate === '' ||
          serviceDate.includes(this.columnFilters.serviceDate);

        return contractDateMatch &&
          salesOrderMatch &&
          productBundleMatch &&
          statusMatch &&
          saleMatch &&
          serviceDateMatch;
      });

      if (this.sortKey) {
        result = [...result].sort((a, b) => {
          let aVal;
          let bVal;

          switch (this.sortKey) {
            case 'agreementDate':
            case 'serviceDate':
              aVal = a[this.sortKey] || '';
              bVal = b[this.sortKey] || '';
              break;
            case 'salesOrderNumber':
            case 'saleNumber':
              aVal = a[this.sortKey] || 0;
              bVal = b[this.sortKey] || 0;
              return this.sortOrder === 'asc' ? aVal - bVal : bVal - aVal;
            default:
              aVal = a[this.sortKey] || '';
              bVal = b[this.sortKey] || '';
          }

          if (typeof aVal === 'string') {
            aVal = aVal.toLowerCase();
            bVal = bVal.toLowerCase();
          }

          if (aVal < bVal) return this.sortOrder === 'asc' ? -1 : 1;
          if (aVal > bVal) return this.sortOrder === 'asc' ? 1 : -1;
          return 0;
        });
      }

      return result;
    },
    markdownToHtml(){
      return marked(this.markdown);
    },
  },
  methods: {
    sortBy(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortKey = key;
        this.sortOrder = 'asc';
      }
    },
    getSortIcon(key) {
      if (this.sortKey !== key) {
        return 'fa fa-sort text-muted';
      }
      return this.sortOrder === 'asc' ? 'fa fa-sort-up' : 'fa fa-sort-down';
    },
    clearColumnFilters() {
      this.columnFilters = {
        contractDate: '',
        salesOrder: '',
        productBundle: '',
        status: '',
        sale: '',
        serviceDate: ''
      };
    },
    getAgreements: function() {
      this.$http.get(this.$config.aimsAPIv2 + "agreements/client/" + this.clientNumber).then(
        (response) => {          
          this.agreements = response.data;
        },
        (error) => {
          console.error(error);
          this.showError("Error Fetching Client Contracts", error);
        }
      )
    },
    getStatuses: function() {
      this.$http.get(this.$config.aimsAPIv2 + "agreements/status").then(
        (response) => {          
          this.statusses = Object.entries(response.data).map(
            ([, label]) => ({ value: label, label })
          );
        },
        (error) => {
          console.error(error);
          this.showError("Error Fetching Contract Statusses", error);
        }
      )
    },
    getActions: function() {
      this.$http.get(this.$config.aimsAPIv2 + "agreements/actions").then(
        (response) => {          
          this.expiryActions = Object.entries(response.data).map(
            ([, label]) => ({ value: label, label })
          );
        },
        (error) => {
          console.error(error);
          this.showError("Error Fetching Contract Actions", error);
        }
      )
    },
    getSales(agreement) {
      const productNumber = parseInt(agreement.sku.split('-')[0], 10);
      this.$http.get(this.$config.aimsAPIv2 + "agreements/client/" + this.clientNumber + "/sales/" + productNumber).then(
        (response) => {          
          this.salesWithDescription = response.data; //sale, productDescription
        },
        (error) => {
          console.error(error);
          this.showError("Error Fetching Client Sales", error);
        }
      )
    },
    openEditAgreeModal(agreement) {
      this.selectedAgreement = this.deepCopyObject(agreement);
      try {
        if (this.selectedAgreement.agreementDate) {
          this.selectedAgreement.agreementDate = this.selectedAgreement.agreementDate.split(' ')[0];
        } else {
          this.selectedAgreement.agreementDate = '';
        }
        if (this.selectedAgreement.expiryDate) {
          this.selectedAgreement.expiryDate = this.selectedAgreement.expiryDate.split(' ')[0];
        } else {
          this.selectedAgreement.expiryDate = '';
        }
      } catch (e) {
        console.error('Error normalizing dates for edit modal', e);
        this.showError('Error preparing dates for edit modal', e);
      }
      this.$refs.editAgreeModal.open();
    },
    openAgreementModal(agreement) {
      this.selectedAgreement = agreement;
      this.$refs.agreementModal.open();
    },
    openLinkSaleModal(agreement) {
      this.selectedSale = '';
      this.selectedAgreement = agreement;
      this.getSales(agreement);
      this.$refs.linkSaleModal.open();
    },
    unlinkSale(agreement) {
      this.selectedSale = '';
      this.selectedAgreement = agreement;
      this.selectedAgreement.agreementStatus = 'Pending';
      this.selectedAgreement.saleNumber=0;
      this.saveAgreement();
    },
    linkSale(agreementNumber) {
      this.selectedAgreement.agreementStatus = 'Active'
      this.selectedAgreement.saleNumber = this.selectedSale.sale.saleNumber;
      this.showSuccess('Sale Linked Successfully');
      this.$refs.linkSaleModal.close();
      this.saveAgreement();
    },
    getBadge: function(status) {
      switch (status) {
        case "Active":
          return "badge badge-green";
        case "Expired":
          return "badge badge-warning";
        case "Pending":
          return "badge bg-warning";
        default:
          return "badge badge-info";
      }
    },
    getStatus: function(status) {
      return status || "N/A";
    },
    saveAgreement() {
      const payload = { ...this.selectedAgreement };
      if (payload.agreementDate === '') payload.agreementDate = null;
      if (payload.expiryDate === '') payload.expiryDate = null;

      this.$http.put(this.$config.aimsAPIv2 + "agreements/update", payload).then(
        (response) => {
          this.showSuccess("Saved Contract")
          this.$refs.editAgreeModal.close();
          this.getAgreements();
        },
        (error) => {
          console.error(error);
          this.showError("Error Saving Contract", error);
        }
      )
    },
    deleteAgreement: function(agreementNumber) {
      this.$swal({
        title: "Are you sure you want to delete this Contract?",
        type: "warning",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
            this.$http.delete(this.$config.aimsAPIv2 + "agreements/delete/"+agreementNumber).then(
                (response) => {
                    this.showSuccess(response.data.message);
                    this.getAgreements();
                },
                (error) => {
                    this.showError("Error Deleting Contract", error);
                }
            );
        }
      });
    },
    confirmAgreement(id) {
      this.showSuccess("Contract Signed")
      this.$refs.agreementModal.close();
    },
    getExpiryLabel(action) {
      const entry = this.expiryActions.find(opt => opt.value === action);
      return entry?.label || action;
    },
    getExpiryIcon(action) {
      const entry = this.expiryActions.find(opt => opt.value === action);
      switch (entry?.value) {
        case "Month to Month":
          return "fa-solid fa-calendar-day text-success";
        case "End of Service":
          return "fa-solid fa-ban text-danger";
        case "Auto Renew":
          return "fa-solid fa-rotate-right text-info";
        default:
          return "fa-solid fa-question";
      }
    },
    getLabel({saleNumber, toString}) {
      return "#" + saleNumber + " - " + toString;
    },
    goToHaloSalesOrder: function(salesOrderNumber) {  
        if (salesOrderNumber) {
            window.open(`https://halo.adept.co.za/order?salesorderid=${salesOrderNumber}`);
        }
    },
    goToSaleWizard: function() {
      this.$refs.linkSaleModal.close();    
      const routeLocation = {
            name: "clientsales",
            params: { clientNumber: this.selectedAgreement.clientNumber},
            query: { sku: this.selectedAgreement.sku },
          };
      this.$router.push(routeLocation);     
    },
    viewSale: function (saleNumber) {
    this.$http.get(this.$config.aimsAPI + "sales/" + saleNumber)
        .then(response => {
            const saleProduct = response.data.product;
            const saleClient = response.data.client
            const productRoute = this.getProductDefinition(saleProduct.productDefinition);

            if (productRoute == -1) {
                this.showWarning(
                    "Could not view sale #" + saleNumber,
                    "'" + saleProduct.description + "' is not supported yet."
                );
            } else {
                this.$router.push({
                    name: productRoute.routeName,
                    params: {
                        clientNumber: saleClient.clientNumber,
                        saleNumber: saleNumber
                    }
                });
            }
        },
        error => {
            console.error(error);
            this.showError("Error Fetching Product for Sale", error);
        });
    },
  },
}
</script>

<style lang="scss" scoped>
.highlight {
  background-color: #58b0c26c;

  &:hover {
    background-color: #58b0c26c;
  }

  td > * {
    color: #474747 !important;
    font-weight: 600;
    outline: none;
    text-decoration: none;
  }

}

.table>thead>tr>th {
  padding: 1em;
  background-color: #3a3f51;
  color: #FFFFFF; 
}

.agreements-table {
  width: 100%;
  table-layout: fixed;
}

.agreements-table-wrapper {
  min-height: 500px;
}

.agreements-table .header-row th {
  padding: 0.65em 0.75em;
  position: sticky;
  top: 0;
  z-index: 2;
}

.agreements-table .column-contract-date {
  width: 95px;
}

.agreements-table .column-status,
.agreements-table .column-service-date {
  width: 130px;
}

.agreements-table .column-sale {
  width: 110px;
}

.agreements-table .column-sales-order {
  width: 140px;
}

.agreements-table .column-product-bundle {
  width: 220px;
}

.agreements-table .column-actions {
  width: 180px;
}

.agreements-table td,
.agreements-table th {
  vertical-align: middle;
}

.cell-truncate {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell-wrap {
  display: block;
  white-space: normal;
  overflow-wrap: anywhere;
}

.actions-cell {
  white-space: nowrap;
}

.sortable-header {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;

  &:hover {
    background-color: #4a5066;
  }

  i {
    margin-left: 5px;
    font-size: 0.85em;
  }
}

.agreements-table .header-row .column-contract-date {
  white-space: normal;
}

.agreements-table .filter-row {
  --standard-filter-control-height: 38px;

  th {
    background-color: #4a5066;
    padding: 0.25em 0.4em;
    position: static;
  }

  input, select {
    width: 100%;
    font-size: 0.85em;
  }

  .form-control-sm {
    box-sizing: border-box;
    min-height: var(--standard-filter-control-height);
    height: var(--standard-filter-control-height);
    padding: 6px 0.35rem;
    line-height: 1.2;
  }

  .btn-sm {
    box-sizing: border-box;
    min-height: var(--standard-filter-control-height);
    height: var(--standard-filter-control-height);
    min-width: 44px;
    padding: 6px 0.35rem;
    line-height: 1.2;
  }
}

.pull-right {
  float: right;
}

.blueLink {
  color: #629EEB;
}

.blueLink:hover {
  cursor: pointer;
  color: #307fe6;
  text-decoration: underline;
}

.expiredAgreement {
    background-color: #F5F5F5;
}
</style>
